var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 8.41797L10.75 11.918L9.41667 9.91797L6.75 12.5846",
    fill: "#FF5449"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 8.41797L10.75 11.918L9.41667 9.91797L6.75 12.5846",
    stroke: "#FF5449",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5833 8.41797H14.25V10.0846",
    stroke: "#FF5449",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 18.8346H13C17.1667 18.8346 18.8334 17.168 18.8334 13.0013V8.0013C18.8334 3.83464 17.1667 2.16797 13 2.16797H8.00002C3.83335 2.16797 2.16669 3.83464 2.16669 8.0013V13.0013C2.16669 17.168 3.83335 18.8346 8.00002 18.8346Z",
    stroke: "#FF5449",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUp);
export default __webpack_public_path__ + "static/media/trend-up.3afd4547a369fd855aab75d1fd442517.svg";
export { ForwardRef as ReactComponent };